export type DonationCurrency = 'ILS' | 'USD';

export type DonationPaymentMethod =
  | 'CreditCard'
  | 'Bit'
  | 'ManualBankTransfer'
  | 'Check';

export interface QuickDonationButton {
  amount: number;
  label: string;
  currency: DonationCurrency;
  months?: number;
}

export interface DonationPageConfig {
  fundId: number;
  fundName: string;
  quickButtons: QuickDonationButton[];
  notifyOnNewDonation: boolean;
  notifyOnApproved: boolean;
  notifyOnRejected: boolean;
  mosadId: number;
  apiValid: string;
  isParentMosad: boolean;
  logoUrl?: string;
}

export interface DonorDetails {
  firstName: string;
  lastName: string;
  israeliId: string;
  phone: string;
  email: string;
  address: string;
  city: string;
}

export interface DonationFormState {
  amount: number;
  months: number;
  chargeDay: number;
  currency: DonationCurrency;
  paymentMethod: DonationPaymentMethod;
  donor: DonorDetails;
}

export const METHODS_BY_CURRENCY: Record<DonationCurrency, DonationPaymentMethod[]> = {
  USD: ['CreditCard'],
  ILS: ['CreditCard', 'Bit', 'ManualBankTransfer', 'Check'],
};

export const BILLING_ENTITY_BY_CURRENCY: Record<DonationCurrency, string> = {
  ILS: 'מרכז הצדקה',
  USD: 'Charity Center',
};
